import React, { ReactNode, useEffect, useRef } from 'react';
import { ButtonRefType } from './Btn';
import { SVG, SVGIcon } from '../../atoms/SVG';

export function useBtn(
  reference: ButtonRefType | undefined,
  focusOnMount: boolean,
  hiddenText: boolean,
  modifier?: string | string[],
  cssClass?: string,
  text?: string,
  svgSpriteId?: SVGIcon,
  svgClass?: string,
  children?: ReactNode,
) {
  const tmpRef = useRef<HTMLButtonElement | HTMLAnchorElement>(null);
  // Here we'll define the reference.
  // once a reference object is given from the parent component we'll use it
  // have a look a look at the defaultprops object to enlighten your mind :)
  const ref = reference || tmpRef;

  // focusing the button ref when its mounted.
  // we need a timeout, for the tooltip to be initialised,
  // as the hyperlink has its own tooltip.
  useEffect(() => {
    if (focusOnMount) {
      setTimeout(() => {
        if (ref && ref?.current) {
          ref?.current.focus();
        }
      }, 100);
    }
  }, []);

  const getText = () => {
    // does the button contain text (visible or invisible)?
    return <span className={hiddenText ? 'invisible' : 'btn__text'}>{text || children}</span>;
  };

  const getIcon = () => {
    if (svgSpriteId) {
      return <SVG svgSpriteId={svgSpriteId} svgClass={svgClass || 'btn__icon'} />;
    }
    return null;
  };

  const hideTooltipFromScreenReader = () => {
    // if hiddenText is set (buttons that consist an icon only),
    // we want to hide the tooltips from screen readers,
    // otherwise the content is read double time there.
    // For further details see SIBZIEL-2806
    return hiddenText;
  };

  const modifierFromProps = Array.isArray(modifier) ? modifier.join(' ') : modifier;

  // gather all css classes in one array
  const cssClasses = ['btn', modifierFromProps, cssClass].join(' ').trim();

  return {
    ref,
    hideTooltipFromScreenReader,
    getText,
    getIcon,
    cssClasses,
  };
}
